import styles from './bmweMenu.module.css';
import { TieredMenu } from 'primereact/tieredmenu';
import { useRouterState } from '@tanstack/react-router';
import { BmweMenuItem } from '../../types';
import { useAuth } from '../../context';

export interface BmweMenuProps {
  items: BmweMenuItem[];
}

export function BmweMenu({ items }: BmweMenuProps) {
  const routerState = useRouterState();
  const { hasPermission } = useAuth();
  const currentPath = routerState.location.pathname;

  const bestMatch = items.reduce<BmweMenuItem | null>((best, item) => {
    const routePath = item.routePath;
    if (!routePath) {
      return best;
    }

    const normalizedRoutePath = routePath.replace(/\/$/, '');
    const normalizedCurrentPath = currentPath.replace(/\/$/, '');

    const isMatch =
      normalizedRoutePath === normalizedCurrentPath ||
      normalizedCurrentPath.startsWith(normalizedRoutePath + '/');

    if (!isMatch) {
      return best;
    }

    const bestRoutePath = best?.routePath;
    if (
      !bestRoutePath ||
      normalizedRoutePath.length > bestRoutePath.replace(/\/$/, '').length
    ) {
      return item;
    }

    return best;
  }, null);

  const mappedItems = items
    .filter((item) => {
      if (item.permission) {
        return hasPermission(item.permission);
      }
      return true;
    })
    .map((item) => ({
      ...item,
      className: item === bestMatch ? 'p-menuitem-active' : undefined,
    }));

  return <TieredMenu model={mappedItems} className={styles.menuContainer} />;
}

export default BmweMenu;
